import { isNil } from 'lodash';

export const checkValidId = (idList: (number | undefined | null)[]): boolean =>
  idList.every((id) => isNil(id) || id > 0);
